import {
  getCountries,
  getCountryCallingCode,
} from 'react-phone-number-input/input';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

export type CountryCode = ReturnType<typeof getCountries>[number];

export const extractExtension = (phone: string): string => {
  const match = phone.match(/ext\s*(\d+)$/i);
  return match ? match[1] : '';
};

export const stripExtension = (phone: string): string => {
  return phone.replace(/\s*ext\s*\d+$/i, '').trim();
};

export const formatLocalNumber = (
  country: CountryCode,
  number: string
): string => {
  const parsed = parsePhoneNumberFromString(number, country);

  if (parsed && ['US', 'CA', 'PR'].includes(parsed.country || '')) {
    return parsed.formatNational();
  }

  return number;
};

export const combinePhoneFull = (
  country: CountryCode,
  localNumber: string,
  extension?: string
): string => {
  const callingCode = '+' + getCountryCallingCode(country);
  let full = `${callingCode} ${localNumber.trim()}`;
  if (extension?.trim()) {
    full += ` ext ${extension.trim()}`;
  }
  return full;
};

export const parseLocalNumber = (phone: string): string => {
  if (!phone.startsWith('+')) {
    return phone.trim();
  }
  return phone.replace(/^\+\d+\s?/, '').trim();
};

export const parseCountryFromPhone = (phone: string): string => {
  if (!phone) return 'US';

  const phoneNumber = parsePhoneNumberFromString(phone);

  return phoneNumber?.country || 'US';
};

export const combinePhone = (
  country: CountryCode,
  localNumber: string
): string => {
  if (!localNumber.trim()) {
    return '';
  }

  const callingCode = '+' + getCountryCallingCode(country);
  return `${callingCode} ${localNumber.trim()}`;
};
